import Lightbox from './lib/react-image-lightbox'

export default Lightbox
